import { RequestTagMultiValuedList } from '../../../../Request'
import { TAG_HEIGHT } from '../../../../Tag'

import * as styles from './AttachedRequests.module.css'

function AttachedRequests({
  className = styles.AttachedRequests,
  items,
  moreProps,
}) {
  return (
    <RequestTagMultiValuedList
      className={className}
      itemProps={{ height: TAG_HEIGHT.height28 }}
      items={items}
      itemsProps={{
        className: styles.itemsList,
      }}
      moreProps={moreProps}
      visibleCount={null}
    />
  )
}

export default AttachedRequests
